<template>
  <div class="fullheight">
    <el-aside
      class="fullheight"
      :width="width"
      style="border-right: 1px solid #eee"
      v-show="asideShow"
    >
      <eco-menu-tree
        highlight-current
        ref="ecoMenuTree"
        :node-key="nodeKey"
        :show-checkbox="showCheckbox"
        :check-strictly="checkStrictly"
        :support-filter="supportFilter"
        :default-expand-all="isExpand"
        :default-checked-keys="defaultCheckedKeys"
        :expand-on-click-node="false"
        @node-click="handleNodeClick"
        :i18nAPi="i18nAPi"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="show-ellipsis" :title="node.label">{{
            node.label
          }}</span>
          <el-dropdown
            @command="handleCommand"
            v-if="!hideMenu && data.parentId"
          >
            <span v-if="data.parentId">
              
                <img
                  src="@/assets/img/iconMore.png"
                  class="iconMore"
                />
            </span>
            <el-dropdown-menu
              slot="dropdown"
              v-show="!hideMenu && data.parentId"
            >
              <el-dropdown-item
                icon="el-icon-circle-plus-outline"
                v-if="data.parentId != ''"
                :command="{ node: node, data, action: 'addHref' }"
                >添加Url菜单</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-plus"
                v-if="data.parentId != ''"
                :command="{ node: node, data, action: 'add' }"
                >添加下级菜单</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-edit"
                v-if="showEdit"
                :command="{ node: node, data, action: 'edit' }"
                >编辑</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-delete"
                v-if="
                  data.parentId != '' &&
                    $store.state.login.currentUser.tenantId ==
                      data.tenantId
                "
                :command="{ node: node, data, action: 'delete' }"
                >删除</el-dropdown-item
              >
              <!-- <el-dropdown-item
                icon="el-icon-s-unfold"
                v-if="data.parentId!='0' && data.parentId!=''"
                divided
                :command="{node:node,data,action:'moveto'}"
              >移动至</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </eco-menu-tree>
    </el-aside>
  </div>
</template>

<script>
import styles from "@/assets/css/element-variables.scss";
const ecoMenuTree = () => import("@/components/system/FeMenuTree.vue");
export default {
  name: "fe-menu-manager",
  components: {
    ecoMenuTree
  },
  props: {
    checkStrictly: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: styles.aside_width
    },
    supportFilter: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    hideMenu: {
      type: Boolean,
      default: false
    },
    defaultCheckedKeys: {
      type: Array
    },
    nodeKey: {
      type: String,
      default: "alias"
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    // 是否展示语言包菜单
    i18nAPi: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    navbarCollapseStyle: function() {
      if (this.asideShow) {
        return { left: parseInt(this.width) + "px" };
      }
      return { left: "0px" };
    }
  },
  data() {
    return {
      asideShow: true,
      isExpand: false,
      dialogVisible: false,
      parentSysType: {
        name: ""
      }
    };
  },
  methods: {
    handleNodeClick(node) {
      this.$emit("node-click", node);
    },
    syncTree() {
      this.$refs.ecoMenuTree.loadData();
    },
    handleExpand() {
      this.isExpand = !this.isExpand;
      let elTree = this.$refs.ecoMenuTree.$refs.ecoMenuTree.$refs.elTree;
      for (var i = 0; i < elTree.store._getAllNodes().length; i++) {
        elTree.store._getAllNodes()[i].expanded = this.isExpand;
      }
    },
    handleCommand(command) {
      this.$emit("menu-action", command);
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .navbar-collapse {
  position: relative;
  top: -60%;
  cursor: pointer;
  width: 20px;
}

>>> .el-dropdown {
  display: none;
}

>>> .el-tree-node__content:hover .el-dropdown {
  display: inline-block;
}

>>> .custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.custom-tree-node i {
  visibility: hidden;
  font-weight: bold;
}

.custom-tree-node:hover i {
  visibility: visible;
}
</style>
